import { Component } from '@angular/core';
import { version } from '../../../../../package.json';

@Component({
  selector: 'app-footer',
  imports: [],
  templateUrl: './footer.html',
  styleUrl: './footer.css',
})
export class Footer {
  year: string = '2025';
  version = version;
  constructor() {
    const currentYear = new Date().getFullYear();
    if (currentYear !== parseInt(this.year)) {
      this.year = `${this.year} - ${currentYear}`;
    }
  }
}
